<template>
  <div
    class="modal fade"
    id="kpiCopyModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" data-dismiss="modal" aria-hidden="true">
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.KCM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="col-md-3 control-label">{{ lang.KCM001 }}</label>
            <div class="col-md-9">
              <select2
                id="kpiCopyModal-source-project-select"
                class="form-control"
                v-if="showModal"
                v-model="selectedSourceProject"
                :placeholder="lang.KCM002"
                :allowClear="true"
              >
                <option
                  v-for="project in projects"
                  :key="project.ProjectGuid"
                  :value="project.ProjectGuid"
                >
                  {{ project.ProjectName }}
                </option>
              </select2>
            </div>
          </div>

          <div class="form-group">
            <label class="col-md-3 control-label">{{ lang.KCM003 }}</label>
            <div class="col-md-9">
              <select2
                id="kpiCopyModal-targetpoject-select"
                class="form-control"
                v-if="showModal"
                v-model="selectedTargetProject"
                :placeholder="lang.KCM004"
                :allowClear="true"
              >
                <option
                  v-for="project in projects"
                  :key="project.ProjectGuid"
                  :value="project.ProjectGuid"
                >
                  {{ project.ProjectName }}
                </option>
              </select2>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-raised" data-dismiss="modal">
            {{ lang.KCM005 }}
          </button>
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="copyKpis()"
            :disabled="!selectedSourceProject || !selectedTargetProject"
          >
            {{ lang.KCM006 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "KPICopyModal",
  components: {
    Select2,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    projects: {
      type: Array,
      default: () => [],
    },
    selectedProject: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedSourceProject: "",
      selectedTargetProject: "",
      lang: {
        KCM000: "Copy KPI Data",
        KCM001: "Source project",
        KCM002: "Please select a source project...",
        KCM003: "Target project",
        KCM004: "Please select a target project...",
        KCM005: "Close",
        KCM006: "Copy",
        KCM007: "Copying to the same project is not possible",
        KCM008: "KPI data copied",
        KCM009: "KPI data copy failed",
      },
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#kpiCopyModal").on("hidden.bs.modal", (e) => this.$emit("modalClosed"));
  },
  methods: {
    openModal() {
      this.selectedSourceProject = "";
      this.selectedTargetProject = "";
      if (this.selectedProject)
        this.selectedSourceProject = this.selectedProject;
      $("#kpiCopyModal").modal("show");
    },
    closeModal() {
      $("#kpiCopyModal").modal("hide");
    },
    copyKpis() {
      if (this.selectedSourceProject === this.selectedTargetProject) {
        console.error(
          "kpi copy not possible due to identical source and target project"
        );
        this.globals.showErrorSnackbar(this.lang.KCM007);
        return;
      }

      let query = `api/KPIs/CopyKPIs/FromProject/${this.selectedSourceProject}/ToProject/${this.selectedTargetProject}`;
      $.ajax({
        method: "POST",
        url: query,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.KCM008);
          this.$emit("copyDone");
          this.closeModal();
        },
        error: (error) => {
          console.error("Error on POST in copyKpis()");
          this.globals.showErrorSnackbar(this.lang.KCM009);
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// KPICopyModal.vue?ca4226ac